define('lib/AppRouter',['require','marionette'],function (require) {
    var Marionette = require('marionette');

    return Marionette.AppRouter.extend({
        onRoute: function(name, path, args) {
            Backbone.Wreqr.radio.vent.trigger('navigation', 'navigate:to', {
                name: name,
                path: path,
                args: args
            });
            // if (!(
            //     window.matchMedia('(display-mode: standalone)').matches ||
            //     ('standalone' in window.navigator && window.navigator.standalone === true)
            // )) {
            //     window.location = '/v2/';
            // }
        }
    });
});
